module.exports = __webpack_public_path__ + "static/media/acctcopy.11e0f75d.svg";